export default __webpack_public_path__ + "static/media/bnb.92643887.png";